<i *ngIf="pack === 'material-icons'" class="material-icons">{{icon}}</i>
<i *ngIf="pack !== 'material-icons'" class="{{pack}} {{icon}}"></i>
